export default function (lodash) {
    const defaultParseErrors = (response) => {
        if (lodash.isEmpty(response.data) || !Array.isArray(response.data)) {
            return {};
        }
        return response.data.reduce((original, error) => {
            if (error.path) {
                // path is translated as string or 1 key
                // original[`${error.path}.${error.field}`] = error.message;
                // path is separated into multiple keys via dot notation
                lodash.set(original, `${error.path}.${error.field}`, error.message);
            }
            else {
                original[error.field] = error.message;
            }
            return original;
        }, {});
    };
    const create = (model, $save, parseErrors = defaultParseErrors) => {
        const originalState = angular.copy(model);
        const resetForm = (form) => {
            form.invalid = false;
            form.saved = false;
            form.errors = {};
        };
        const resetModel = (form) => {
            form.model = angular.copy(originalState);
        };

        const form = {
            errors: {},
            saving: false,
            invalid: false,
            saved: false,
            model: angular.copy(model),
            save: (params) => {
                form.saving = true;
                resetForm(form);
                return $save(form.model, params)
                    .then((returnModel) => {
                        form.saved = true;
                        form.invalid = false;
                        return returnModel;
                    })
                    .catch((response) => {
                        form.invalid = true;
                        form.saved = false;
                        form.errors = parseErrors(response);
                        throw response;
                    })
                    .finally(() => {
                        form.saving = false;
                    });
            },
            reset: () => {
                resetForm(form);
                resetModel(form);
            },
            parseErrors: (errors) => {
                form.errors = parseErrors(errors);
            },
            cleanErrors: () => resetForm(form)
        };
        return form;
    };

    return {
        create,
        createFromResource: ($resource, params = {}) => {
            const $save = (model, saveParams = {}) => {
                lodash.assign(params, saveParams);
                if (model.id) {
                    params.id = model.id;
                }
                return model.id ? model.$update(params) : model.$save(params);
            };
            return create($resource, $save);
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/factories/form/index.js